
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
    Consultant (Academics) 
</h2>
<!-- 
<p class="para_main_notify">
  Skills Acquisition and Knowledge Awareness for Livelihood Promotion (SANKALP) is an outcome-oriented centrally sponsored program supported by World Bank.
</p> -->
  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">


        >

            <!-- feature box begin -->
            <div class="col-md-12 feature-box mb40 sq-item wow">
              <div class="feature-box style-2 left">
                <i class="fa fa-gavel" aria-hidden="true"></i>
                <div class="text para_cls">
                  <h3>	Key responsibilities:</h3>
              
                    <p> <span class="step_no">1</span>Reporting and Assisting Senior officials in various projects.</p>
                    <p> <span class="step_no">2</span>Development of digital e-learning content for Blended learning project in NIMI</p>
                    <p> <span class="step_no">3</span>Training of trainers PAN India on Blended Learning.</p>
                    <p> <span class="step_no">4</span>Generating monthly and quarterly reports and Data Monitoring</p>
					<p> <span class="step_no">5</span>Coordination between headquarters and regional office.</p>
					<p> <span class="step_no">6</span>Coordination with instructors in the development of trade books for NIMI</p>
                    <p> <span class="step_no">7</span>Translation Process of NIMI books.</p>
                    <p> <span class="step_no">8</span>Question Bank Management.</p>
					<p> <span class="step_no">9</span>Any other responsibility given by the Competent Authority</p>

          
                </div>
              </div>
            </div>
            <!-- feature box close -->

        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Qualification: </h3>
              <p> <span class="step_no">1</span>Post-Graduation from recognized University/ Institute.</p>
			

            </div>
          </div>
        </div>
        <!-- feature box close -->




  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-history"></i>
      <div class="text para_cls">
        <h3>Experience:</h3>
        <p> <span class="step_no">1</span>A minimum of 3 years of experience in the field of training or teaching in any University or Educational Institution in India or abroad.</p>
		
		
       </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Remuneration:</h3>
        <p> <span class="step_no">1</span> Rs. 40,000/- to Rs. 50,000/- per month    </p>
        <p> <span class="step_no">2</span> Will be paid a monthly compensation as stated above. No further allowances are payable on this amount.    </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b> Last date for Applying Online 21 st September 2021 </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>Skills and Competencies:</h3>
        <p><span class="step_no">1</span>Proficiency in writing and fluency in speaking in English.</p>
        <p><span class="step_no">2</span>Strong analytical, interpersonal and computer skills.</p>
        <p><span class="step_no">3</span>Working knowledge in Computer using MS-Office and fluency in other regional languages</p>

		

      </div>
    </div>
  </div>
  <!-- feature box close -->


    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Nature of engagement:</h3>
        <p><span class="step_no">1</span>The engagement is purely on temporary basis, and it will not confirm him/her any claim for regular employment in NIMI.</p>
		<p><span class="step_no">2</span>The above-mentioned posts of “Consultant” will be on contract basis initially for a period of one year which may be extendable as per requirement of NIMI and performance of the consultant.</p>


      </div>
    </div>
  </div>
  <!-- feature box close -->
    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Locations</h3>
        <p>New Delhi</p>
	
		
		


      </div>
    </div>
  </div>
  <!-- feature box close -->
  
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Selection Process:</h3>
        <p><span class="step_no">1</span>Applicant shall be considered for selection basis meeting the minimum  eligibility criteria mentioned in the invitation for application.</p>
		<p><span class="step_no">2</span>Applicant who fulfils the required eligibility conditions should produce their original certificates and other documents on the date and time communicated to them in support of their claim in age, educational qualification and experience..</p>
		<p><span class="step_no">3</span>Application for afore mentioned position of “Consultant” here does not insure selection of candidate. The application and selection criteria mentioned are only for the purpose of shortlisting, and NIMI reserves the right to select or reject any candidate applying for the position at any stage of the process.</p>
        <p><span class="step_no">4</span>Applicant attending skill test and personal interview would not be paid any TA-DA by NIMI. </p>
        <p><span class="step_no">5</span>NIMI reserves the right to cancel this recruitment process at any time without providing any prior notice to the applicants. Employment under this application shall be contractual in nature and terms of the same shall be governed by offer extended and contract signed thereof between NIMI and selected applicant. </p>

      </div>
    </div>
  </div>
  <!-- feature box close -->
  


  

  
  


  <div class="container big_padd">








      </div>


    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>
